<template>
    <div id="top-element" class="bb-1 pb-5 mb-5">
        <h5 class="h5-updated pull-right mr-4" v-if="!isadmin">Nominee Entry Status: <span :class="entryVideoStatus">{{entryVideoStatus}}</span></h5>

        <div class="description" v-if="maxvideos > 1">For this category, {{maxvideos}} videos are required.</div>

        <div class="video-component-wrapper">
            <div class="row fullwidth">
                <div class="left large-4 entrant-left video-filename-listing col-12 col-md-4">
                    <ul>
                        <draggable class="drag-episode-titles" v-model="videofiles" @start="drag=true" @end="drag=false, updateWeights()">
                            <li class="video-filename-item" :class="leftSidebarClass(index, video)" v-for="(video, index) in videofiles" @click="videoActive(index)">
                                <div v-if="video.pivot.episode_title">{{index+1}} - {{video.pivot.episode_title}}
                                    <div class="action-icons action-wrapper-class" v-if="videofiles.length > 1">
                                        <div class="move">
                                            <span class="actions">Reorder<br>Videos</span><i class="fa fa-arrows-v"></i>
                                        </div>
                                        <div v-if="maxvideos == -1" class="delete-wrapper-class" @click.prevent="activateDeleteVideoPopup(video, index)">
                                            <i class="fa fa-trash deleteEntrant"></i>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>{{index+1}} - Add video file <div v-if="maxvideos == -1" class="action-icons pull-right" @click.prevent="activateDeleteVideoPopup(video, index)"><i class="fa fa-trash deleteEntrant"></i></div></div>
                            </li>
                        </draggable>
                    </ul>
                    <a href="#" class="btn btn-create yellow" v-if="maxvideos == -1" @click.prevent="addNewVideo()"><i class="fa fa-custom-circle"></i><span>Add new video upload</span></a>
                </div>
                <div class="right large-8 omega video-entry-right-form pt-4 col-12 col-md-8">
                    <div v-for="(video, index) in videofiles">
                        <div class="vid-wrapper" v-if="index == activeVideoIndex">
                            <div class="filename-wrapper">
                                <h4 class="mb-0 pr-1 pull-left" style="line-height: 21px;">Video File: </h4>
                                <span id="vid_file_name" class="filename" v-text="video.filename"></span>
                                <span v-if="isadmin && video.audio_type == '5.1'" class="border-2-black ml-3">5.1</span>
                            </div>
                            <div class="file-info pb-2">
                                <h4 class="mb-0 pr-1 pull-left displaybloc mt-0" style="line-height: 21px;">Video File Status:</h4>
                                <div class="display-inline valign-middle" v-if="!video.id">Select a video file</div>
                                <div  class="display-inline valign-middle" v-if="video.id && !isadmin" v-text="statusDisplay(video.status)"></div>
                                <Select2 v-if="isadmin && video.id" v-model="video.status" :options="VIDEOSTATUSES" :settings="{placeholder: 'Video File Status'}" @change="applyChange(video)" ></Select2>
                            </div>
                            <div class="row clear-both pt-2 fullwidth">

                                <div :class="video.asset_id ? 'col-5' : 'col-12'" v-show="video.asset_id" @click="setDropzoneClickIndex(index)">
                                    <div class="video-placeholder" v-if="video.asset_id">
                                        <video-file :filename="video.filename" :asset_id="video.asset_id" :episode="video.pivot.episode_title" :is_admin="isadmin"></video-file>
                                    </div>
                                </div>

                                <div class="col-7">
                                    <div class="image-wrapper">

                                        <div class="file-select-items" v-if="!video.id">
                                            <a v-if="!video.asset_id" class="btn btn-primary displaybloc last" @click.prevent="selectFileModal(index)"><i class="fa fa-caret-down"></i>Select File</a>
                                        </div>
                                        <div class="button-wrapper" v-if="video.id">
                                            <a v-if="isadmin" :href="video.temporary_object_url" download class="btn btn-primary"><i class="fa fa-download"></i> Download</a>
                                            <a href="#" class="btn btn-primary" @click.prevent="activateDeleteVideoPopup(video, index)"><i class="fa fa-trash"></i> Remove</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="video-text-info-wrapper" v-if="video.id">
                                <div class="video-info clear-both pt-2" v-if="requiredfields['showEpisodeField'] == '1'">
                                    <div class="form-group-beside" :class="(video.required && video.required.episode) ? 'required' : ''">
                                        <label for="episode">Episode Number <em class="yellow no-style" v-if="requiredfields['episodeFieldRequired'] == 1">*</em></label>
                                        <Select2 id="episode" :options="episodeArray" v-model="video.pivot.episode" @change="applyChange(video)"></Select2>
                                    </div>
                                </div>
                                <div class="file-info-fields clear-both mt-0">
                                    <div class="form-group-beside" :class="(video.readonly_episodetitle) ? 'locked' : (video.required && video.required.episode_title) ? 'required' : ''">
                                        <label class="" for="episode_title">Episode Title <em class="yellow no-style" v-if="requiredfields['episodeTitleFieldRequired'] == '1'">*</em></label>
                                        <input id="episode_title" type="text" class="form-control" v-model="video.pivot.episode_title" @change.prevent="applyChange(video)" :readonly="video.readonly_episodetitle && !isadmin">
                                    </div>
                                    <div class="form-group-beside logline-video-upload" :class="(video.readonly_logline) ? 'locked' : (video.required && video.required.logline) ? 'required' : ''">
                                        <label class="" for="log_line">Episode Description  <em class="yellow no-style" v-if="requiredfields['loglineFieldRequired'] == '1'">*</em></label>
                                        <textarea rows="5" type="text" id="log_line" class="form-control" v-model="video.pivot.logline" @change.prevent="applyChange(video, index)" @keyup="wordCountFixer(video.pivot.logline)" :readonly="video.readonly_logline && !isadmin"></textarea>
                                        <div class="placeholder-text" v-if="!video.pivot.logline && !isadmin">Limited to {{maxWords}} words</div>
                                        <div class="limited-to-text red" v-if="showWordCountMax">You are <span v-text="numberOver"></span> over the limit. </div>
                                    </div>
                                </div>
                                <div class="file-info-fields clear-both mt-0" v-if="requiredfields['closedCaptionFieldRequired'] != 'No' && video.id" :class="(video.required && video.required.CCFileUrl) ? 'required' : ''">
                                    <div class="form-group-beside" :class="video.CCFileUrl && video.id ? 'locked' : ''">
                                    <label :class="video.CCFileUrl && video.id ? 'cc-file-exists ' : 'no-cc-file'" for="closed_caption">Closed Captioning Upload <em class="yellow no-style" v-if="requiredfields['closedCaptionFieldRequired'] == 'Required'">*</em></label>
                                        <div id="closed_caption" class="filename" v-if="video.CCFileUrl">
                                            <span>{{ video.CCFilename }}</span><span class="pl-3 pointer" @click.prevent="activateDeleteCCFilePopup(video, index)"><i class="fa fa-trash"></i></span>
                                        </div>
                                        <div class="cc-download-option" v-if="video.newCCUrl && video.CCFileUrl">
                                            <a :href="video.newCCUrl" class="btn btn-primary displaybloc" download><i class="fa fa-download"></i> Download</a>
                                        </div>
                                        <vue-dropzone v-show="ccFile" class="video-placeholder" v-if="!video.CCFileUrl && video.id" ref="myVueDropzone" :id="'dropzone'+index" :options="dropzoneOptions" v-on:vdropzone-success="successCallback" v-on:vdropzone-sending="sendingCallback" v-on:vdropzone-file-added="acceptCallback"></vue-dropzone>
                                        <a v-if="!video.CCFileUrl" href="#" class="btn btn-primary displaybloc" @click.prevent="activateDropzone(index)"><i class="fa fa-upload"></i> Upload</a>
                                    </div>
                                    <div class="form-group-beside" :class="video.CCFileUrl && video.id ? 'locked' : ''" v-if="isadmin && video.CCFileUrl">
                                        <label :class="video.CCFileUrl && video.id ? 'cc-file-exists ' : 'no-cc-file'" for="closed_caption">Closed Captioning Status </label>
                                        <div>{{video.cc_status}}</div>

                                    </div>
                                    <div class="form-group-beside" :class="video.CCFileUrl && video.id ? 'locked' : ''" v-if="isadmin && video.CCFileUrl">
                                        <label :class="video.CCFileUrl && video.id ? 'cc-file-exists ' : 'no-cc-file'" for="closed_caption">Closed Captioning Offset (+/- in seconds)</label>
                                        <input type="text" class="form-control" v-model="video.cc_file_offset" >
                                        <button v-if="video.cc_file_offset || video.cc_file_offset===0" @click="video.cc_file_offset+=' processing'; applyChange(video)">Process Closed Caption Offset</button>
                                    </div>
                                </div>

                                <div class="file-info-fields clear-both mt-0" v-if="requiredfields['audioDescriptionFieldRequired'] != 'No' && video.id" :class="(video.required && video.required.audio_description_file_url) ? 'required' : ''">
                                    <div class="form-group-beside" :class="video.audio_description_file_url && video.id ? 'locked' : ''">
                                        <label :class="video.audio_description_file_url && video.id ? 'cc-file-exists ' : 'no-cc-file'" for="audio_description_file">Audio Description Upload <em class="yellow no-style" v-if="requiredfields['audioDescriptionFieldRequired'] == 'Required'">*</em></label>
                                        <div id="audio_description_file" class="filename" v-if="video.audio_description_file_url">
                                            <span style="word-break: break-all;">{{ video.audio_description_filename }}</span><span class="pl-3 pointer" @click.prevent="activateDeleteAudioDescriptionFilePopup(video, index)"><i class="fa fa-trash"></i></span>
                                        </div>
                                        <div class="cc-download-option" style="margin-left: 50%;" v-if="video.new_audio_description_url && video.audio_description_file_url">
                                            <a :href="video.new_audio_description_url" class="btn btn-primary displaybloc" download><i class="fa fa-download"></i> Download</a>
                                        </div>
                                        <div class="form-group-beside" :class="video.audio_description_file_url && video.id ? 'locked' : ''" v-if="isadmin && video.audio_description_file_url">
                                            <label :class="video.audio_description_file_url && video.id ? 'cc-file-exists ' : 'no-cc-file'" for="audio_description_file">Audio Description Status </label>
                                            <div>{{video.audio_description_status}}</div>

                                        </div>
                                        <vue-dropzone v-show="audioDescriptionFile" class="video-placeholder" v-if="!video.audio_description_file_url && video.id" ref="myVueDropzoneAudio" :id="'dropzone'+index + '-audio'" :options="dropzoneOptionsAudioDescription" v-on:vdropzone-success="successAudioDescriptionCallback" v-on:vdropzone-sending="sendingCallback" v-on:vdropzone-file-added="acceptCallbackAudio"></vue-dropzone>
                                        <a v-if="!video.audio_description_file_url" href="#" class="btn btn-primary displaybloc" @click.prevent="activateDropzone(index + '-audio')"><i class="fa fa-upload"></i> Upload</a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!isadmin" class="submit-video-entry-button"><a href="#" class="btn btn-primary" @click.prevent="triggerConfirmSubmit()">Submit Nominated Entry Videos</a></div>
            </div>

            <modal v-if="modalTrigger" @close="modalTrigger = false">
                <h3 slot="header">Select Video File</h3>
                <div class="content" slot="body">
                    <div class="existing-videos-wrapper">
                        <Select2 v-model="exisitingVideoSelected" :options="existingvideos" :settings="{placeholder: 'Select Video'}" ></Select2>
                    </div>
                </div>
                <div class="form-group-submit clearfix" slot="footer">
                    <button class="btn btn-cancel btn-transparent pull-left" @click="modalTrigger = false">Close</button>
                    <button class="pull-right" @click="saveClonedVideo">Add video</button>
                </div>
            </modal>
            <modal v-if="modalTriggerConfirmDelete" @close="modalTriggerConfirmDelete = false">
                <h3 slot="header">Removing Video File</h3>
                <div class="content" slot="body">
                    <div v-if="videoModalDelete.filename">Are you sure you want to remove {{videoModalDelete.filename}} from this entry? It will not delete the video.</div>
                    <div v-else>Are you sure you want to remove this item?</div>
                </div>
                <div class="form-group-submit clearfix" slot="footer">
                    <button class="btn btn-cancel btn-transparent pull-left" @click="modalTriggerConfirmDelete = false">Cancel</button>
                    <button class="pull-right" @click="deleteVideo(videoModalDelete.id)">Yes, Remove</button>
                </div>
            </modal>
            <modal v-if="modalTriggerConfirmCCRemove" @close="modalTriggerConfirmCCRemove = false">
                <h3 slot="header">Removing Closed Captioning File</h3>
                <div class="content" slot="body">
                    <div v-if="videoModalDelete.CCFilename">Are you sure you want to remove {{videoModalDelete.CCFilename}} from this entry?</div>
                    <div v-else>Are you sure you want to remove this item?</div>
                </div>
                <div class="form-group-submit clearfix" slot="footer">
                    <button class="btn btn-cancel btn-transparent pull-left" @click="modalTriggerConfirmCCRemove = false">Cancel</button>
                    <button class="pull-right" @click="removeCCFile(videoModalDelete.id)">Yes, Remove</button>
                </div>
            </modal>
            <modal v-if="modalTriggerConfirmAudioDescriptionRemove" @close="modalTriggerConfirmAudioDescriptionRemove = false">
                <h3 slot="header">Removing Audio Description File</h3>
                <div class="content" slot="body">
                    <div v-if="videoModalDelete.audio_description_filename">Are you sure you want to remove {{videoModalDelete.audio_description_filename}} from this entry?</div>
                    <div v-else>Are you sure you want to remove this item?</div>
                </div>
                <div class="form-group-submit clearfix" slot="footer">
                    <button class="btn btn-cancel btn-transparent pull-left" @click="modalTriggerConfirmAudioDescriptionRemove = false">Cancel</button>
                    <button class="pull-right" @click="removeAudioDescriptionFile(videoModalDelete.id)">Yes, Remove</button>
                </div>
            </modal>
            <modal v-if="modalTriggerConfirmSubmit" @close="modalTriggerConfirmSubmit = false">
                <h3 slot="header">Submit Nominated Entry Videos</h3>
                <div class="content" slot="body">
                    Are you sure you want to submit the videos for this nominated entry? You cannot edit this section after submitting.
                </div>
                <div class="form-group-submit clearfix" slot="footer">
                    <button class="btn btn-cancel btn-transparent pull-left" @click="modalTriggerConfirmSubmit = false">Cancel</button>
                    <button class="pull-right" @click="submitVideoEntry()">Submit</button>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    const VIDEOSTATUSES = [
        'Canceled',
        'Deleted',
        'Under Review',
        'Need More Info',
        'Video Approved'
    ];
    // import dropzoneS3Single from './DropZoneS3Single.vue';
    import modal from './Modal.vue';
    import videoFile from './Videofile.vue';
    import Select2 from 'v-select2-component';
    import vueDropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import AWS from 'aws-sdk/global';
    import S3 from 'aws-sdk/clients/s3';
    import axios from 'axios';
    export default {
        name: "VideoUploadComponent",
        components: {modal, Select2, vueDropzone, videoFile},
        props: {
            initialdata : Array,
            videoobject : Array,
            maxvideos: String,
            entryid: String,
            userid: String,
            isadmin: {
                type: Boolean,
                default: false,
            },
            submitterid: String,
            nominee_video_status: String,
            captioning: String,
            bucketname: String,
            catsettingsrequiredfields: {
              type: Object,
              default: function() {
                  return {
                      'episodeTitleFieldRequired': 1,
                      'episodeFieldRequired': 1,
                      'showEpisodeField': 1
                  }
              }
            }
        },
        data() {
            return {
                VIDEOSTATUSES: VIDEOSTATUSES,
                ccFile: false,
                audioDescriptionFile: false,
                episodeArray: ['Select'].concat(Array.from({length: 30}, (_, index) => index + 1)),
                modalTrigger: false,
                modalTriggerConfirmDelete: false,
                modalTriggerConfirmCCRemove: false,
                modalTriggerConfirmAudioDescriptionRemove: false,
                modalTriggerConfirmSubmit: false,
                entryVideoStatus: this.nominee_video_status,
                requiredfields: this.catsettingsrequiredfields,
                confirmSubmitClicked: false,
                buttonDisabled: true,
                videoModalDelete: '',
                videostatus: '',
                videofiles: this.setInitialVideoFile(),
                existingvideos: [],
                exisitingVideoSelected: '',
                activeVideoIndex: 0,
                maxWords: 50,
                numberOver: '',
                showWordCountMax: false,
                videoObjectDetails: {
                    'id': '',
                    'filename': '',
                    'CCFilename': '',
                    'CCFileUrl': '',
                    'audio_description_filename': '',
                    'audio_description_file_url': '',
                    'pivot': {
                        'episode': '',
                        'episode_title': '',
                        'logline': '',
                    },
                    'required': {
                        'CCFileUrl': false,
                        'episode': false,
                        'episode_title': false,
                        'logline': false,
                    }
                },
                dropzoneOptions: {
                    thumbnailWidth: 150,
                    autoQueue: false,
                    // The URL will be changed for each new file being processing
                    url: '/',
                    maxFilesize: 300000, // 300GB
                    timeout: 172800000, // 48 hours in miliseconds
                    // Since we're going to do a `PUT` upload to S3 directly
                    method: 'put',
                    dictDefaultMessage: '',
                    // Hijack the xhr.send since Dropzone always upload file by using formData
                    // ref: https://github.com/danialfarid/ng-file-upload/issues/743
                    // sending (file, xhr) {
                    //     let _send = xhr.send
                    //     xhr.send = () => {
                    //         _send.call(xhr, file)
                    //     }
                    // },
                    // Upload one file at a time since we're using the S3 pre-signed URL scenario
                    parallelUploads: 10,
                    uploadMultiple: false,
                    // Content-Type should be included, otherwise you'll get a signature
                    // mismatch error from S3. We're going to update this for each file.
                    header: '',
                    // We're going to process each file manually (see `accept` below)
                    autoProcessQueue: true,
                    acceptedFiles: '.vtt,.scc',
                    // accept: this.acceptCallback, // use our custom acceptCallback
                    // canceled : this.abortUpload,
                    // complete: this.completeUpload,
                    sending: function(file, xhr) {
                        var _send = xhr.send;
                        xhr.send = function() {
                            _send.call(xhr, file);
                        }
                    }
                },
                dropzoneOptionsAudioDescription: {
                    autoQueue: false,
                    // The URL will be changed for each new file being processing
                    url: '/',
                    maxFilesize: 300000, // 300GB
                    timeout: 172800000, // 48 hours in miliseconds
                    // Since we're going to do a `PUT` upload to S3 directly
                    method: 'put',
                    dictDefaultMessage: '',
                    // Hijack the xhr.send since Dropzone always upload file by using formData
                    // ref: https://github.com/danialfarid/ng-file-upload/issues/743
                    // sending (file, xhr) {
                    //     let _send = xhr.send
                    //     xhr.send = () => {
                    //         _send.call(xhr, file)
                    //     }
                    // },
                    // Upload one file at a time since we're using the S3 pre-signed URL scenario
                    parallelUploads: 10,
                    uploadMultiple: false,
                    // Content-Type should be included, otherwise you'll get a signature
                    // mismatch error from S3. We're going to update this for each file.
                    header: '',
                    // We're going to process each file manually (see `accept` below)
                    autoProcessQueue: true,
                    acceptedFiles: '.wav,.mp3,.m4a',
                    // accept: this.acceptCallback, // use our custom acceptCallback
                    // canceled : this.abortUpload,
                    // complete: this.completeUpload,
                    sending: function(file, xhr) {
                        var _send = xhr.send;
                        xhr.send = function() {
                            _send.call(xhr, file);
                        }
                    }
                }
            }
        },
        created: function() {
            let app = this;
            this.submitVideoEntryButtonStatus();
            if(!app.requiredfields.showEpisodeField) {
                app.requiredfields.showEpisodeField = '1';
            }
        },
        mounted () {
            AWS.config.region = 'us-west-2'; // Region
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: 'us-west-2:f916f8a9-1780-4953-a74b-75d5607638af',
            });
        },
        methods: {
            statusDisplay(inputStatus) {
                switch (inputStatus) {
                    case 'Upload Failed':
                        return 'Upload Failed';
                    case 'Uploading':
                        return 'Uploading...';
                    case 'Need More Info':
                        return 'Needs More Information';
                    case 'Canceled':
                        return 'Canceled';
                    case 'Video Approved':
                        return 'Video Approved';
                    case 'Processing Failed':
                        return 'Under Review';
                    default:
                        return 'Under Review';
                }
            },
            setInitialVideoFile: function() {
                let app = this;
                let videoF = [];

                    if(videoF.length < app.maxvideos) {
                        for (var i = videoF.length; i < app.maxvideos; i++) {
                            let episodeTitle = '';
                            let logline = '';
                            let readonly_logline = false;
                            let readonly_episodetitle = false;
                            if (app.initialdata[i]) {
                                if (app.initialdata[i].episode != "") {
                                    readonly_episodetitle = true;
                                    episodeTitle = app.initialdata[i].episode;
                                }
                                if (app.initialdata[i].logline != "") {
                                    readonly_logline = true;
                                    logline = app.initialdata[i].logline;
                                }
                            }

                            videoF.push({
                                'id': '',
                                'filename': '',
                                'CCFilename': '',
                                'CCFileUrl': '',
                                'audio_description_filename': '',
                                'audio_description_file_url': '',
                                'readonly_episodetitle': readonly_episodetitle,
                                'readonly_logline': readonly_logline,
                                'pivot': {
                                    'weight' : i,
                                    'episode': '',
                                    'episode_title': episodeTitle,
                                    'logline': logline,
                                },
                                'required': {
                                    'CCFileUrl': false,
                                    'episode': false,
                                    'episode_title': false,
                                    'logline': false,
                                }
                            });
                        }
                    } else if ((app.maxvideos == -1) && (videoF.length == 0)) {
                        var i = 0;
                        let episodeTitle = '';
                        let logline = '';
                        let readonly_logline = false;
                        let readonly_episodetitle = false;
                        if (app.initialdata[i]) {
                            if (app.initialdata[i].episode != "") {
                                readonly_episodetitle = true;
                                episodeTitle = app.initialdata[i].episode;
                            }
                            if (app.initialdata[i].logline != "") {
                                readonly_logline = true;
                                logline = app.initialdata[i].logline;
                            }
                        }
                        videoF.push({
                            'id': '',
                            'filename': '',
                            'CCFilename': '',
                            'CCFileUrl': '',
                            'audio_description_filename': '',
                            'audio_description_file_url': '',
                            'readonly_episodetitle': readonly_episodetitle,
                            'readonly_logline': readonly_logline,
                            'pivot': {
                                'weight' : i,
                                'episode': '',
                                'episode_title': episodeTitle,
                                'logline': logline,
                            },
                            'required': {
                                'CCFileUrl': false,
                                'episode': false,
                                'episode_title': false,
                                'logline': false,
                            }
                        });
                    }

                    // inject user data in
                    app.videoobject.forEach(function(i,v) {
                        if (app.initialdata[i.pivot.weight]) {
                            if (app.initialdata[i.pivot.weight].episode != "") {
                                i.readonly_episodetitle = true;
                                if (i.pivot.episode_title == "" || i.pivot.episode_title == null) {
                                    i.pivot.episode_title = app.initialdata[i.pivot.weight].episode;
                                }
                            }
                            if (app.initialdata[i.pivot.weight].logline != "") {
                                i.readonly_logline = true;
                                if (i.pivot.logline == "" || i.pivot.logline == null) {
                                    i.pivot.logline = app.initialdata[i.pivot.weight].logline;
                                }
                            }
                        }
                        let tt = i;
                        tt.required = {
                            'CCFileUrl': false,
                            'episode': false,
                            'episode_title': false,
                            'logline': false,
                        };
                        videoF[i.pivot.weight] = tt;
                    });

                    // make sure none of them are undefined
                var filtered = videoF.filter(function(item) {
                    return item !== undefined;
                });
                return filtered
            },
            applyChange: function(video, index) {
                let app = this;
                let vfo_id = app.videofiles[app.activeVideoIndex].id;
                let actionUrl = '/video/update/' + vfo_id;
                // let actionUrl = '/video/update-pivot/' + app.entryid + '/' + video.id;

                // Now do the word count
                let logLine = '';
                if(video.pivot.logline) {
                    if(!app.isadmin) {
                        logLine = app.logLineWordCountFormat(video.pivot.logline, index);
                        if (window.countWords(logLine) > app.maxWords) {
                            let logLineFull = logLine.replace(/[ ]{2,}/gi, " ");
                            logLine = logLineFull.split(" ").splice(0, app.maxWords).join(" ");
                            app.videofiles[index].pivot.logline = logLine;
                            app.numberOver = '';
                            app.showWordCountMax = false;
                        }
                    } else {
                        logLine = video.pivot.logline;
                    }
                }

                axios(
                    {
                        method: 'POST',
                        url: actionUrl,
                        data: {
                            id: video.id,
                            entry_id: app.entryid,
                            status: video.status,
                            filename: video.filename,
                            episode: video.pivot.episode,
                            episode_title: video.pivot.episode_title,
                            cc_file_offset: video.cc_file_offset,
                            weight: video.pivot.weight,
                            logline: logLine
                        }
                    }).then(function(response) {
                        app.videofiles[app.activeVideoIndex].cc_status = response.data.cc_status;
                        app.videofiles[app.activeVideoIndex].cc_file_offset = response.data.cc_file_offset;
                        app.modalTrigger = false;
                        app.submitVideoEntryButtonStatus();
                        if(app.confirmSubmitClicked) {
                            app.underlineFields();
                        }
                }).catch(function (error) {
                    // handle error
                    console.log('This is the error returned', error);
                });
            },
            videoActive: function(index) {
                let app = this;
                app.activeVideoIndex = index;
            },
            addNewVideo: function() {
                let app = this;
                app.activeVideoIndex = app.videofiles.length;
                app.videofiles.push({
                    'id': '',
                    'filename': '',
                    'pivot': {
                        'episode': 'Select',
                        'episode_title': '',
                        'logline': '',
                    },
                    'required': {
                        'episode': false,
                        'episode_title': false,
                        'logline': false,
                    }
                })
            },
            selectFileModal: function(index) {
                // This looks up all the current videos the user has
                let app = this;
                app.activeVideoIndex = index;
                axios(
                    {
                        method: 'GET',
                        url: `/api/upload/user_vfos/${app.userid}/${app.entryid}`,
                    })
                .then(function(response) {
                    app.existingvideos = response.data;
                    // This adds the filename as a 'text' value for the select2 vue component
                    app.existingvideos.forEach(function(i,v) {
                       app.existingvideos[v].text = i.filename + ' - '+i.created_display
                    });
                    app.modalTrigger = true;
                }).catch(function (error) {
                    // handle error
                    console.log('This is the error returned', error);
                });
            },
            saveClonedVideo: function() {
                let app = this;

                // This finds the file details selected
                var selectedFile = app.existingvideos.filter(function(number) {
                    return number.id == app.exisitingVideoSelected;
                });
                app.videofiles[app.activeVideoIndex].filename = selectedFile[0].filename;
                app.videofiles[app.activeVideoIndex].CCFilename = selectedFile[0].CCFilename;
                app.videofiles[app.activeVideoIndex].CCFileUrl = selectedFile[0].CCFileUrl;
                app.videofiles[app.activeVideoIndex].audio_description_filename = selectedFile[0].audio_description_filename;
                app.videofiles[app.activeVideoIndex].audio_description_file_url = selectedFile[0].audio_description_file_url;
                app.videofiles[app.activeVideoIndex].status = selectedFile[0].status;
                app.modalTrigger = false;
                var weight = app.activeVideoIndex;

                // console.log(selectedFile);
                axios(
                    {
                        method: 'POST',
                        data: {
                          weight: weight
                        },
                        url: '/video/clone/'+selectedFile[0].id+'/'+app.entryid
                    })
                    .then(function(response) {
                        //console.log(response, 'this is returned from the clone');
                        // Then save the video id in the Axios return .... like the following
                        if (selectedFile[0].id == response.data) {
                            app.videofiles[app.activeVideoIndex].id = selectedFile[0].id;
                            app.applyChange(app.videofiles[app.activeVideoIndex], app.activeVideoIndex);
                        } else {
                            alert('There was a problem attaching the video');
                        }
                    }).catch(function (error) {
                        // handle error
                        console.log('This is the error returned', error);
                        alert('There was a problem attaching the video');
                    });

            },
            wordCountFixer: function(text) {
                let app = this;
                let numberWords = window.countWords(text);
                if ((numberWords > app.maxWords) && (!app.isadmin)) {
                    app.numberOver = numberWords - app.maxWords;
                    app.showWordCountMax = true;
                } else {
                    app.showWordCountMax = false;
                }
            },
            logLineWordCountFormat(logLine, index) {
                let app = this;
                var logLineText = logLine;
                if(window.countWords(logLine) > app.maxWords) {
                    let logLineFull = logLine.replace(/[ ]{2,}/gi," ");
                    logLine = logLineFull.split(" ").splice(0, app.maxWords).join(" ");
                    app.videofiles[index].pivot.logline = logLine;
                    app.numberOver = '';
                    app.showWordCountMax = false;
                }
                return logLineText;
            },
            sendFileStatus(file) {
                let app = this;
                let vfo_id = app.videofiles[app.activeVideoIndex].id;
                let actionUrl = '/video/update/' + vfo_id;
                // console.log('send file status', file);
                axios.post(actionUrl, {
                    id: vfo_id,
                    CCFileUrl: file.s3key,
                    CCFilename: file.name
                })
                    .then(function(response) {
                        app.videofiles[app.activeVideoIndex].CCFilename = file.name;
                        app.videofiles[app.activeVideoIndex].CCFileUrl = file.s3key;
                        app.videofiles[app.activeVideoIndex].cc_status = response.data.cc_status;
                        app.submitVideoEntryButtonStatus();
                    }).catch(function (error) {
                        // handle error
                        console.log('CC error', error)
                        app.videofiles[app.activeVideoIndex].CCFileUrl = '';
                    });
            },
            sendAudioDescriptionFileStatus(file) {
                let app = this;
                let vfo_id = app.videofiles[app.activeVideoIndex].id;
                let actionUrl = '/video/update/' + vfo_id;
                // console.log('send file status', file);
                axios.post(actionUrl, {
                    id: vfo_id,
                    audio_description_file_url: file.s3key,
                    audio_description_filename: file.name
                })
                    .then(function(response) {
                        app.videofiles[app.activeVideoIndex].audio_description_filename = file.name;
                        app.videofiles[app.activeVideoIndex].audio_description_file_url = file.s3key;
                        app.videofiles[app.activeVideoIndex].audio_description_status = response.data.audio_description_status;
                        app.submitVideoEntryButtonStatus();
                    }).catch(function (error) {
                    // handle error
                    console.log('audioDescription error', error)
                    app.videofiles[app.activeVideoIndex].audio_description_file_url = '';
                });
            },
            completeUpload(file) {
                // contains name, size, s3upload, type, status:"uploading", processing:true, upload.filename
                // console.log(file);
                // Fire AJAX call to controller to let it know it's done
                this.sendFileStatus(file);
                //this.dropzone.removeFile(file);

            },
            startUpload() {
                let vm = this;
                console.log('starting upload');
                // console.log(this.dropzone.getFilesWithStatus(Dropzone.ADDED), 'dropzone added');
                let files = this.dropzone.getFilesWithStatus(Dropzone.ADDED);
                files.forEach(function(file){
                    vm.dropzone.processFile(file)
                });
            },
            cancelAllUploads() {
                console.log('cancel');
                this.dropzone.removeAllFiles(true);
            },
            abortUpload(file) {
                console.log('Abort Upload');
                if (file.s3upload) file.s3upload.abort();
                this.sendFileStatus(file);
            },
            successCallback(file, response){
                // console.log('success', file);
                console.log(response);

                this.sendFileStatus(file);
            },
            successAudioDescriptionCallback(file, response){
                // console.log('success', file);
                console.log(response);

                this.sendAudioDescriptionFileStatus(file);
            },
            sendingCallback(file, xhr, formData) {
                xhr.timeout = 99999999;
            },
            acceptCallback(file, dzone) {
                console.log('acceptCallback method');
                let vm = this;
                var ext = file.name.substr(file.name.lastIndexOf('.') + 1);
                var filename = `captionfile_${vm.submitterid}_${Date.now()}.${ext}`;
                //console.log(this);

                // get signed url for upload
                let app = this;
                axios.get('/api/signed_url', {
                    params: {
                        filename: filename,
                        filetype: file.type,
                        uploadtype: 'caption'
                    }
                })
                .then(function(response) {
                    file.s3key = response.data.s3_key;
                    app.$refs.myVueDropzone[0].dropzone.URL = response.data.signed_url;
                    app.$refs.myVueDropzone[0].dropzone.options.url = response.data.signed_url;
                    app.$refs.myVueDropzone[0].dropzone.processFile(file);
                })


                // console.log(file, 'file');



                // options for the managed upload for this accepted file
                // define the bucket, and the S3 key the file will be stored as

                //this.sendFileStatus(file);
                // automatically start the uploads (comment it out if you want to use the start upload button)
                //setTimeout(() => vm.dropzone.processFile(file))
            },
            acceptCallbackAudio(file, dzone) {
                console.log('acceptCallback audio method');
                let vm = this;
                var ext = file.name.substr(file.name.lastIndexOf('.') + 1);
                var filename = `audiofile_${vm.submitterid}_${Date.now()}.${ext}`;
                //console.log(this);

                // get signed url for upload
                let app = this;
                axios.get('/api/signed_url', {
                    params: {
                        filename: filename,
                        filetype: file.type,
                        uploadtype: 'audio'
                    }
                })
                    .then(function(response) {
                        file.s3key = response.data.s3_key;
                        app.$refs.myVueDropzoneAudio[0].dropzone.URL = response.data.signed_url;
                        app.$refs.myVueDropzoneAudio[0].dropzone.options.url = response.data.signed_url;
                        app.$refs.myVueDropzoneAudio[0].dropzone.processFile(file);
                    })


                // console.log(file, 'file');



                // options for the managed upload for this accepted file
                // define the bucket, and the S3 key the file will be stored as

                //this.sendFileStatus(file);
                // automatically start the uploads (comment it out if you want to use the start upload button)
                //setTimeout(() => vm.dropzone.processFile(file))
            },
            sendFile(file, dzelement) {
                // console.log('sending file through AWS sdk');
                file.s3upload.send(function(err, data) {
                    if (err) {
                        console.log(err.message);
                        dzelement.emit("error", file, err.message);
                    } else {
                        console.log('complete');
                        file.status = Dropzone.SUCCESS;
                        dzelement.emit("success", file, 'success', null);
                        dzelement.emit("complete", file);

                    }
                });

                // listen to the AWS httpUploadProgress event, and emit an equivalent Dropzone event
                file.s3upload.on('httpUploadProgress', function(progress) {
                    if (progress.total) {
                        var percent = ((progress.loaded * 100) / progress.total);
                        dzelement.emit('uploadprogress', file, percent, progress.loaded);
                    }
                });
            },
            activateDropzone: function(index) {
                $('#dropzone' + index).click();
            },
            activateDeleteVideoPopup(video, index) {
                let app = this;
                app.modalTriggerConfirmDelete = true;
                app.videoModalDelete = video;
                app.activeVideoIndex = index;
            },
            deleteVideo: function(videoid) {
                let app = this;
                if(!videoid) {
                    app.videofiles.splice(app.activeVideoIndex, 1);
                    app.modalTriggerConfirmDelete = false;
                    if(app.activeVideoIndex != 0) {
                        app.activeVideoIndex = app.activeVideoIndex-1;
                    } else {
                        app.activeVideoIndex = 0;
                    }
                    return;
                }

                let indexlist= [];
                app.videofiles.splice(app.activeVideoIndex, 1);
                app.videofiles.forEach(function(video, index){
                    indexlist[index] = video.id;
                });
                // console.log(indexlist);

                let actionUrl = `/api/video/detach`;
                axios(
                    {
                        method: 'POST',
                        data: {
                            'video_id':videoid,
                            'entry_id':app.entryid,
                            'token': false,
                            'indexlist' : indexlist,
                        },
                        url: actionUrl,
                    }).then(function(response) {
                    app.modalTriggerConfirmDelete = false;
                    //app.videofiles.splice(app.activeVideoIndex, 1)
                    //app.activeVideoIndex = 0;
                    window.location.reload();
                }).catch(function (error) {
                    // handle error
                    console.log('This is the error returned', error);
                });
            },
            setDropzoneClickIndex: function(index) {
                this.dropzoneIndex = index;
            },
            submitVideoEntryButtonStatus: function() {
                // Controls the status of the Video Entry Button Status
                // If all required fields are filled in with the proper number of videos it'll be enabled
                let app = this;
                app.buttonDisabled = false;
                if(app.maxvideos > 0) {
                    if(app.videofiles.length != app.maxvideos) {
                        app.buttonDisabled = true
                    }
                }
                app.videofiles.forEach(function(i,v) {
                    if((!i.filename) || (!i.pivot.episode_title && app.requiredfields['episodeTitleFieldRequired'] == '1') || (!i.pivot.logline && app.requiredfields['loglineFieldRequired'] == '1') || (!i.pivot.episode && app.requiredfields['episodeFieldRequired'] == '1')) {
                        app.buttonDisabled = true;
                    }
                    if(app.requiredfields['closedCaptionFieldRequired'] == 'Required' && i.CCFileUrl == "") {
                        app.buttonDisabled = true;
                    }
                });
            },
            submitVideoEntry: function() {
                let app = this;
                let actionUrl = `/video/entry/${app.entryid}`;
                axios(
                    {
                        method: 'POST',
                        url: actionUrl,
                        data: {
                            nominee_video_status: 'Submitted'
                        }
                    }).then(function(response) {
                        app.modalTriggerConfirmSubmit = false;
                        app.entryVideoStatus = 'Submitted';
                        app.$emit("submitted", app.entryVideoStatus);
                        window.location.reload();
                    }).catch(function (error) {
                        // handle error
                        console.log('This is the error returned', error);
                        alert('There was an issue submitting this entry. Please try again.');
                    });
            },
            triggerConfirmSubmit: function() {
                let app = this;
                app.confirmSubmitClicked = true;
                if(app.buttonDisabled) {
                    app.underlineFields();
                    $('html, body').animate({
                        scrollTop: $("#top-element").offset().top
                    }, 300);
                } else {
                    app.modalTriggerConfirmSubmit = true
                }
            },
            underlineFields: function() {
                let app = this;
                app.videofiles.forEach(function(i,v) {
                    if(!i.CCFileUrl && app.requiredfields['closedCaptionFieldRequired'] == 'Required') {
                        app.videofiles[v].required.CCFileUrl = true;
                    } else {app.videofiles[v].required.CCFileUrl = false;}
                    if(!i.pivot.episode_title && app.requiredfields['episodeTitleFieldRequired'] == '1') {
                        app.videofiles[v].required.episode_title = true;
                    } else {app.videofiles[v].required.episode_title = false;}
                    if (!i.pivot.logline && app.requiredfields['loglineFieldRequired'] == '1') {
                        app.videofiles[v].required.logline = true;
                    } else {app.videofiles[v].required.logline = false;}
                    if (!i.pivot.episode && app.requiredfields['episodeFieldRequired'] == '1') {
                        app.videofiles[v].required.episode = true;
                    } else {app.videofiles[v].required.episode = false;}
                });
            },
            leftSidebarClass: function(index, video) {
                let app = this;
                let sidebarClass = '';
                if(index == app.activeVideoIndex) {
                    sidebarClass = 'active';
                }

                if(Object.values(video.required).includes(true)) {
                    sidebarClass += ' required';
                }

                return sidebarClass;
            },
            activateDeleteCCFilePopup(video, index) {
                let app = this;
                app.modalTriggerConfirmCCRemove = true;
                app.videoModalDelete = video;
                app.activeVideoIndex = index;
            },
            activateDeleteAudioDescriptionFilePopup(video, index) {
                let app = this;
                app.modalTriggerConfirmAudioDescriptionRemove = true;
                app.videoModalDelete = video;
                app.activeVideoIndex = index;
            },
            updateWeights: function() {
                let app = this;
                var weightIdValues = app.videofiles.map(function(x, index){
                    var weightIdObject = {
                        'id': x.id,
                        'weight': index
                    };
                    return(weightIdObject)
                });

                let actionUrl = `/video/updateweights`;
                axios(
                    {
                        method: 'POST',
                        url: actionUrl,
                        data: {
                            entry_id: app.entryid,
                            weights: weightIdValues
                        }
                    }).then(function(response) {
                    console.log('response');
                }).catch(function (error) {
                    // @TODO pass the error on to the user so they know
                    //  handle error
                    console.log('This is the error returned', error);
                    alert('There was a problem changing the order of the videos');
                });
            },
            removeCCFile: function(vid) {
                let app = this;
                let vfo_id = app.videofiles[app.activeVideoIndex].id;
                let actionUrl = '/video/update/' + vfo_id;

                axios(
                    {
                        method: 'POST',
                        url: actionUrl,
                        data: {
                            id: vid,
                            CCFileUrl: '',
                            CCFilename: '',
                            cc_status: '',
                            cc_file_offset: ''
                        }
                    }).then(function(response) {
                    app.videofiles[app.activeVideoIndex].CCFileUrl = '';
                    app.videofiles[app.activeVideoIndex].CCFilename = '';
                    app.videofiles[app.activeVideoIndex].cc_status = '';
                    app.videofiles[app.activeVideoIndex].cc_file_offset = '';
                    app.submitVideoEntryButtonStatus();
                    app.modalTriggerConfirmCCRemove = false;
                }).catch(function (error) {
                    // handle error
                    console.log('This is the error returned', error);
                });
            },
            removeAudioDescriptionFile: function(vid) {
                let app = this;
                let vfo_id = app.videofiles[app.activeVideoIndex].id;
                let actionUrl = '/video/update/' + vfo_id;

                axios(
                    {
                        method: 'POST',
                        url: actionUrl,
                        data: {
                            id: vid,
                            audio_description_file_url: '',
                            audio_description_filename: '',
                            audio_description_status: '',
                        }
                    }).then(function(response) {
                    app.videofiles[app.activeVideoIndex].audio_description_file_url = '';
                    app.videofiles[app.activeVideoIndex].audio_description_filename = '';
                    app.videofiles[app.activeVideoIndex].audio_description_status = '';
                    app.submitVideoEntryButtonStatus();
                    app.modalTriggerConfirmAudioDescriptionRemove = false;
                }).catch(function (error) {
                    // handle error
                    console.log('This is the error returned', error);
                });
            },
        }
    }
</script>

<style scoped>
    .select2-container--default .select2-results>.select2-results__options {
        max-height: 300px;
    }
</style>
